import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledContainer = styled.div`
  padding: 1rem;
  padding-top: 35px;

  ${themeMedia.desktop`
    padding-top: 50px;
  `}
`

export const StyledTextWrapper = styled.div`
  p {
    font-size: 22px;
    text-align: center;
  }
`

export const StyledTitle = styled.p`
  font-weight: 400;
  margin: 0;

  ${themeMedia.desktop`
    font-size: 25px !important;
  `}
`

export const StyledInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
`

export const StyledForm = styled.form`
  button {
    margin-top: 45px;
  }
`

export const StyledFirstRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  ${themeMedia.desktop`
    grid-template-columns: 2fr 1fr;
    gap: 18px;
  `}
`

export const StyledSecondRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  ${themeMedia.desktop`
    grid-template-columns: 1fr 1fr;
    gap: 18px;
  `}
`

export const StyledCheckboxLabel = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`
